import { useMemo } from "react"
import { useSubscription } from "react-relay"
import { graphql, GraphQLSubscriptionConfig } from "relay-runtime"
import {
  useSteeringLevelsSubscription as useSteeringLevelsSubscriptionType,
  useSteeringLevelsSubscription$data,
} from "@/modules/admin/capacity/services/__generated__/useSteeringLevelsSubscription.graphql"

const subscription = graphql`
  subscription useSteeringLevelsSubscription {
    steeringLevelsChanged {
      id
      level
      language
      levelValue
      isAutomatic
    }
  }
`

const useSteeringLevelsSubscription = (
  onNext?: (data: useSteeringLevelsSubscription$data | null | undefined) => void,
) => {
  const subscriptionConfig: GraphQLSubscriptionConfig<useSteeringLevelsSubscriptionType> = useMemo(
    () => ({
      variables: {},
      subscription,
      onError: (error: Error) => console.error(`An error occurred while subscribe to SteeringLevels:`, error),
      onNext: (data) => {
        onNext?.(data)
      },
      onCompleted: () => {
        console.log("server closed the SteeringLevels subscription ")
      },
    }),
    [onNext],
  )

  return useSubscription<useSteeringLevelsSubscriptionType>(subscriptionConfig)
}

export { useSteeringLevelsSubscription }
